import(/* webpackMode: "eager" */ "/codebuild/output/src3735643423/src/globallynx-report-system/components/atoms/Paragraph.module.scss");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3735643423/src/globallynx-report-system/components/atoms/Title.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3735643423/src/globallynx-report-system/components/organisms/web-forms/session-management/PasswordRecovery.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3735643423/src/globallynx-report-system/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3735643423/src/globallynx-report-system/public/assets/images/logo/logo-globallynx.png");
